import "./WeddingDetails.module.css";
import DropshippingHero from "@/reusable_sections/Header";
import ProcedureCenters from "./sections/ProcedureCenters";
import OurPrinciplesAndValues from "./sections/OurPrinciplesAndValues";
import Faq from "./sections/Faq";
import BrandFooter from "@/reusable_sections/Footer";
export default function WeddingDetailsPage() {
  return <div>
      <DropshippingHero />
      <ProcedureCenters />
      <OurPrinciplesAndValues />
      <Faq />
      <BrandFooter />
    </div>;
}